module.exports = {"130111100":"栾城镇","130111103":"冶河镇","130111104":"窦妪镇","130111105":"楼底镇","130111200":"南高乡","130111201":"柳林屯乡","130111202":"西营乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130111.json
// module id = 149
// module chunks = 0